import TimeBlock from '@/entities/TimeBlock'

export default class TimeBlocks {
  constructor (options = {}) {
    return this.getTimeBlocks(Object.values(options))
  }

  getTimeBlocks (blocks) {
    const dateTimeFormat = new Intl.DateTimeFormat('en-us', { month: 'short', day: 'numeric', year: '2-digit' })
    return blocks.reduce((blocksByDate, block) => {
      const timestamp = Date.parse(new Date(`${block?.date}T${block?.start_time}`))
      if (isNaN(timestamp)) {
        return blocksByDate
      }

      const blockDate = new Date(`${block.date}T${block.start_time}`)
      const formattedDate = dateTimeFormat.format(blockDate)
      const dateArray = blocksByDate[formattedDate] || []
      return {
        ...blocksByDate,
        [formattedDate]: [...dateArray, new TimeBlock(block)]
      }
    }, {})
  }
}
